import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Tooltip,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import TablePagination from "../TablePagination/TablePagination";
import NoDataAvailable from "../NoDataAvailable/NoDataAvailable";
import "./dynamicTable.scss";
import IconButtons from "../IconButtons/IconButtons";
import { font_13 } from "../../utils/utils";
import Loader from "../Loader/Loader";
import { useState } from "react";


const DynamicTable = ({
  title = "Records",
  columns = [],
  rows = [],
  totalResult = 0,
  totalPages = 0,
  currentPage = 1,
  handlePageChange,
  actions = [],
  isLoading = false,
  tableHeaderColor = "#ffffff",
  showPagination = true,
  onSort,
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);


    if (onSort) {
      onSort(property, newOrder);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Loader />
      </Box>
    );
  }

  return (
    <>
      <TableContainer className="table-container" sx={{
        overflow: showPagination ? "auto" : "visible",
      }}>
        <Table stickyHeader aria-label="dynamic table">
          <TableHead className="table-head-container">
            <TableRow className="table-head-row" sx={{ "& .MuiTableCell-head": { backgroundColor: tableHeaderColor, position: "sticky", top: 0, zIndex: 10 } }}>
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  align={col.align || "left"}
                  sx={{ minWidth: col.minWidth || "8rem", maxWidth: "13rem" }}
                  className="padding-left-1"
                  sortDirection={orderBy === col.key ? order : false}
                >
                  {col.sortable ? (
                    <TableSortLabel
                      active={orderBy === col.key}
                      direction={orderBy === col.key ? order : "asc"}
                      onClick={() => handleRequestSort(col.key)}
                    >
                      <Tooltip title={col.tooltip || ""}>
                        <Typography variant="font_13_bold">{col.label}</Typography>
                      </Tooltip>
                      {orderBy === col.key ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc" ? "sorted descending" : "sorted ascending"}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  ) : (
                    <Tooltip title={col.tooltip || ""}>
                      <Typography variant="font_13_bold">{col.label}</Typography>
                    </Tooltip>
                  )}
                </TableCell>
              ))}
              {actions?.length > 0 && (
                <TableCell
                  align="center"
                  sx={{ minWidth: "8rem" }}
                  className="padding-left-1 padding-right-1"
                >
                  <Typography variant="font_13_bold">Actions</Typography>
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, rowIndex) => (
                <TableRow className="table-body-row " sx={{ padding: "0.5rem 0rem", }} hover key={rowIndex} style={{ verticalAlign: "center" }}>
                  {columns.map((col) => (
                    <TableCell
                      key={col.key}
                      align={col.align || "left"}
                      className="padding-left-1"
                    ><Typography

                      variant="font_12">
                        {typeof col.render === "function"
                          ? col.render(row[col.key], row)
                          : row[col.key]}
                      </Typography>
                    </TableCell>
                  ))}

                  {actions?.length > 0 && (
                    <TableCell align="center" className="padding-left-1 padding-right-1">
                      <Box className="topic-action-icons">
                        {actions.map((action, actionIndex) => (
                          <IconButtons
                            key={actionIndex}
                            tooltip={action.tooltip}
                            image={action.icon}
                            handleClick={() => action.onClick(row)}
                            disabled={typeof action.disabled === "function"
                              ? action.disabled(row)
                              : action.disabled}
                            disabledImage={action.disabledImage}
                            disabledTooltip={action.disabledTooltip}
                            width={font_13}
                            height={font_13}
                            classList="margin-right-1"
                          />
                        ))}
                      </Box>
                    </TableCell>
                  )}

                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <NoDataAvailable
                    imgHeight={4}
                    imgWidth={4.5}
                    message={`No ${title} Available`}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {showPagination && rows.length > 0 && (
        <Grid
          container
          className="table-pagination-container"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="font_16">Total {totalResult} Records</Typography>
          <TablePagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        </Grid>
      )}
    </>
  );
};

export default DynamicTable;
